import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
    constructor(private msg: MessageService) { }

    success(detail: string, summary = 'تمت العملية بنجاح'): void {
        this.msg.add({ severity: 'success', summary, detail, life: 4000 });
    }

    error(detail: string, summary = 'حدث خطأ'): void {
        this.msg.add({ severity: 'error', summary, detail, life: 5000 });
    }

    warn(detail: string, summary = 'تنبيه'): void {
        this.msg.add({ severity: 'warn', summary, detail, life: 4000 });
    }

    info(detail: string, summary = 'معلومة'): void {
        this.msg.add({ severity: 'info', summary, detail, life: 4000 });
    }
}